"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _detectBrowser = require("detect-browser");

var _Error = _interopRequireDefault(require("./../Messages/Error"));

var _ValidationIcons = _interopRequireDefault(require("./../Inputs/ValidationIcons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useClickOutside = function useClickOutside(ref, handler) {
  (0, _react.useEffect)(function () {
    var listener = function listener(e) {
      if (e.keyCode === 27) return handler();
      ref.current && !ref.current.contains(e.target) && handler();
    };

    document.addEventListener('keyup', listener);
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      document.removeEventListener('keyup', listener);
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};

var DateInput = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
      name = _ref.name,
      disabled = _ref.disabled,
      error = _ref.error,
      touched = _ref.touched,
      value = _ref.value,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      validate = _ref.validate,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["className", "name", "disabled", "error", "touched", "value", "onBlur", "onChange", "validate", "children"]);

  // Pad the value -> pad(4) returns '04', pad(11) returns '11'
  var pad = function pad(n) {
    if (!parseInt(n)) return '';
    return parseInt(n) < 10 ? "0".concat(parseInt(n)) : n;
  };

  var init = function init() {
    if (_typeof(value) === 'object') return {
      day: pad(value.day),
      month: pad(value.month),
      year: value.year
    };
    var values = value.split('/');
    return {
      day: pad(values[0]),
      month: pad(values[1]),
      year: values[2]
    };
  };

  var _useReducer = (0, _react.useReducer)(function (state, _ref2) {
    var type = _ref2.type,
        payload = _ref2.payload;

    switch (type) {
      case 'day':
        return _extends({}, state, {
          day: payload
        });

      case 'month':
        return _extends({}, state, {
          month: payload
        });

      case 'year':
        return _extends({}, state, {
          year: payload
        });

      default:
        return _extends({}, state);
    }
  }, init(value)),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      date = _useReducer2[0],
      dispatch = _useReducer2[1];

  var browser = (0, _detectBrowser.detect)();

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      focus = _useState2[0],
      setFocus = _useState2[1];

  var _useState3 = (0, _react.useState)('1rem'),
      _useState4 = _slicedToArray(_useState3, 2),
      iconRight = _useState4[0],
      setIconRight = _useState4[1];

  var dayRef = (0, _react.useRef)();
  var monthRef = (0, _react.useRef)();
  var yearRef = (0, _react.useRef)();
  var ARROW_LEFT = 37;
  var ARROW_UP = 38;
  var ARROW_RIGHT = 39;
  var ARROW_DOWN = 40;
  useClickOutside(ref, function () {
    return setFocus(false);
  });

  var isDate = function isDate() {
    var d = "".concat(date.day, "/").concat(date.month, "/").concat(date.year);
    return /\d{2}\/\d{2}\/\d{4}/.test(d);
  };

  (0, _react.useEffect)(function () {
    if (!isDate()) return;
    if (validate && !validate("".concat(date.day, "/").concat(date.month, "/").concat(date.year))) return;
    onChange({
      name: name,
      value: "".concat(date.day, "/").concat(date.month, "/").concat(date.year)
    });
    !touched && setFocus(false);
  }, [date.day, date.month, date.year]);
  var prevRef = {
    day: null,
    month: dayRef,
    year: monthRef
  };
  var nextRef = {
    day: monthRef,
    month: yearRef,
    year: null
  }; // Change focus to the field with the classname in the nextField argument

  var focusField = function focusField(field) {
    if (!field) return;
    field.current.focus();
    field.current.setSelectionRange(0, field.current.getAttribute('data-maxlengthvalue'));
  };

  var setRange = function setRange(e) {
    e.preventDefault();
    e.target.setSelectionRange(0, e.target.getAttribute('data-maxlengthvalue'));
  };

  var keyDownHandler = function keyDownHandler(e, max, min) {
    if (![8, 37, 38, 39, 40].includes(e.keyCode)) return true;
    var type = e.target.id;
    e.preventDefault();

    if (e.keyCode === ARROW_UP || e.keyCode === ARROW_DOWN) {
      if (date[type] === '') return dispatch({
        type: type,
        payload: '01'
      });
      if (parseInt(date[type]) < min || parseInt(date[type]) > max) return false;
      if (e.keyCode === ARROW_UP && parseInt(date[type]) < max) dispatch({
        type: type,
        payload: pad(parseInt(date[type]) + 1)
      });else if (e.keyCode === ARROW_DOWN && parseInt(date[type]) > min) dispatch({
        type: type,
        payload: pad(parseInt(date[type]) - 1)
      });
      setRange(e);
    } else if ([ARROW_LEFT, 8].includes(e.keyCode)) {
      focusField(prevRef[type]);
      type === 'day' && setRange(e);
      e.keyCode === 8 && dispatch({
        type: type,
        payload: ''
      });
    } else if (ARROW_RIGHT === e.keyCode) {
      setRange(e);
      focusField(nextRef[type]);
    }
  };

  var handleFocus = function handleFocus() {
    setFocus(true);
    if (!browser) return;

    switch (browser.name) {
      case ['', 'safari'].includes(browser.name):
        setIconRight('3.5rem');
        break;

      default:
        setIconRight('1rem');
    }
  }; // Single functions to handle all blurs


  var blurHandlerType = function blurHandlerType(_ref3, max, min) {
    var id = _ref3.id,
        value = _ref3.value;
    if (value === '') return false;
    var inRange = parseInt(value) < max && parseInt(value) >= min;
    var tempInput = inRange ? pad(value) : pad(date[id][0]);
    dispatch({
      type: id,
      payload: tempInput
    });
  };

  var handleBlurInput = function handleBlurInput(_ref4) {
    var _ref4$target = _ref4.target,
        id = _ref4$target.id,
        value = _ref4$target.value;
    if (id === 'year') dispatch({
      type: 'year',
      payload: value
    });

    switch (id) {
      case 'day':
        blurHandlerType({
          id: id,
          value: value
        }, 32, 0);
        break;

      case 'month':
        blurHandlerType({
          id: id,
          value: value
        }, 13, 0);
    }
  };

  var handleChangedInputForType = function handleChangedInputForType(_ref5, max, min) {
    var id = _ref5.id,
        value = _ref5.value;
    var type = id;
    var tempValue;
    if (isNaN(value)) tempValue = pad(isNaN(date[type]) ? 1 : date[type]);else if (parseInt(value) < min || parseInt(value) > max) {
      tempValue = date[type] ? date[type] : 1;
    }

    if (type === 'year') {
      tempValue = value.length > 4 ? date[type] : value;
    } else {
      tempValue = value.length > 2 ? date[type] : value;
    }

    dispatch({
      type: type,
      payload: tempValue
    });
    value.length === 2 && focusField(nextRef[type]);
  };

  var handleChangedInput = function handleChangedInput(e) {
    if (!/^\d{1,4}$/.test(e.target.value)) return;
    e.persist();
    handleChangedInputForType(e.target, 32, 0);
  }; // const handleCalendarChange = dateStr => {
  //   const date = new Date(dateStr);
  //   const payload = {
  //     day: pad(date.getDate()),
  //     month: pad(date.getMonth() + 1),
  //     year: date.getFullYear(),
  //   };
  //   setFocus(false);
  //   dispatch({ type: 'full', payload });
  // };


  var onFocus = function onFocus(_ref6) {
    var target = _ref6.target;
    target.setSelectionRange(0, target.getAttribute('data-maxlengthvalue'));
  }; // const calendarDate = date.day
  //   ? new Date(
  //       date.year,
  //       parseInt(date.month) - 1 > -1 ? parseInt(date.month) - 1 : date.month,
  //       date.day,
  //     )
  //   : new Date();


  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    className: className,
    ref: ref
  }, otherProps), /*#__PURE__*/_react.default.createElement(StyledLabel, {
    disabled: disabled,
    htmlFor: name
  }, children, /*#__PURE__*/_react.default.createElement(Input, {
    error: error,
    touched: touched,
    onFocus: handleFocus,
    onBlur: onBlur
  }, /*#__PURE__*/_react.default.createElement(StyledSingleInputDate, {
    value: date.day,
    "data-maxlengthvalue": 2,
    maxLength: 2,
    maxValue: 31,
    onBlur: handleBlurInput,
    onChange: handleChangedInput,
    placeholder: "DD",
    type: "text",
    autoComplete: "off",
    ref: dayRef,
    onFocus: onFocus,
    min: 1,
    onKeyDown: function onKeyDown(e) {
      return keyDownHandler(e, 31, 1);
    }
  }), '/', /*#__PURE__*/_react.default.createElement(StyledSingleInputDate, {
    value: date.month,
    "data-maxlengthvalue": 2,
    maxLength: 2,
    maxValue: 12,
    onBlur: handleBlurInput,
    onChange: handleChangedInput,
    placeholder: "MM",
    type: "text",
    ref: monthRef,
    autoComplete: "off",
    onFocus: onFocus,
    min: 1,
    onKeyDown: function onKeyDown(e) {
      return keyDownHandler(e, 12, 1);
    }
  }), '/', /*#__PURE__*/_react.default.createElement(StyledSingleInputDate, {
    value: date.year,
    maxLength: 4,
    "data-maxlengthvalue": 9999,
    ref: yearRef,
    onBlur: handleBlurInput,
    onChange: handleChangedInput,
    placeholder: "YYYY",
    type: "text",
    autoComplete: "off",
    onFocus: onFocus,
    minLength: 1,
    min: 1,
    onKeyDown: function onKeyDown(e) {
      return keyDownHandler(e, 9999, 0);
    }
  })), /*#__PURE__*/_react.default.createElement(_ValidationIcons.default, {
    error: error,
    browser: browser,
    focus: focus,
    iconRight: iconRight,
    touched: touched
  })), /*#__PURE__*/_react.default.createElement(_Error.default, {
    error: error
  }));
}); // const StyledCalendar = styled(Calendar)`
//   min-width: 27rem;
//   position: absolute;
//   z-index: 2;
// `;

var Input = _styledComponents.default.div.withConfig({
  displayName: "Input"
})(["display:flex;align-items:center;position:relative;font-size:1.5rem;width:100%;box-sizing:border-box;overflow:hidden;justify-content:flex-start;background-color:white;padding-left:1.2rem;height:4rem;margin-top:1.4rem;border:0.1rem solid;border-color:", ";border-radius:0.3rem;"], function (_ref7) {
  var error = _ref7.error,
      touched = _ref7.touched,
      theme = _ref7.theme;
  return error ? theme.status.error : touched && !error ? theme.status.succes : theme.ui.outline;
});

Input.displayName = 'Input';

var StyledLabel = _styledComponents.default.label.withConfig({
  displayName: "StyledLabel"
})(["display:flex;flex-direction:column;position:relative;width:100%;font-size:1.4rem;color:", ";line-height:1rem;"], function (props) {
  return props.disabled ? '#AEAEAE' : '#5B5550';
});

var StyledSingleInputDate = _styledComponents.default.input.withConfig({
  displayName: "StyledSingleInputDate"
})(["flex-grow:0;flex-shrink:0;width:", ";border:none;letter-spacing:0.1rem;align-items:center;background-color:rgba(0,0,0,0);display:block;padding:0.2rem;text-align:center;font-size:1.5rem;&:focus{outline:none;}&::placeholder{letter-spacing:0;}"], function (_ref8) {
  var id = _ref8.id;
  return id === 'year' ? '5rem' : '2.9rem';
});

var Container = _styledComponents.default.div.withConfig({
  displayName: "Container"
})(["width:100%;font-family:", ";position:relative;height:9rem;"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.font;
});

Container.displayName = 'Container';
DateInput.displayName = 'DateInput';
DateInput.defaultProps = {
  disabled: false,
  touched: false,
  isCalendarEnabled: false,
  otherProps: {},
  value: '',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {}
};
DateInput.propTypes = {
  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,

  /** name of input and label */
  name: _propTypes.string,

  /** label above the input */
  children: _propTypes.node,

  /** type of input: email, text, ... */
  disabled: _propTypes.bool,

  /** example value in the input */
  error: _propTypes.string,

  /** show calendar on focus */
  isCalendarEnabled: _propTypes.bool,

  /** object with inputname and boolean to check if touched */
  touched: _propTypes.bool,

  /** Callback function that is fired when blurring the input field. */
  onBlur: _propTypes.func,

  /** Callback function that is fired when focusing the input field. */
  onChange: _propTypes.func,

  /** Callback function that is fired when the component's value changes. */
  onFocus: _propTypes.func,

  /** Current value of the input element as { day: 'DD', month: 'MM', year: 'YYYY' } */
  value: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.shape)({
    day: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    month: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    year: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
  })]),
  validate: _propTypes.func,

  /** Adds extra props to the element */
  otherProps: _propTypes.object
};
var _default = DateInput;
exports.default = _default;